const US_STATES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'AA',
  'AE',
  'AP',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

const ARMED_FORCES = ['AA', 'AE', 'AP'];

export const US_TERRITORIES = ['AS', 'FM', 'GU', 'MH', 'MP', 'PR', 'VI'];

export const US_FIFTY_STATES = US_STATES.filter(
  state => !ARMED_FORCES.includes(state)
);

export const IP_PAYABLE_STATES = US_FIFTY_STATES;

export default US_STATES;
